<template>
  <client-only>
    <Teleport to="body">
      <div
          v-if="isOpen"
          :style="{ zIndex: overlayZIndex }"
          class="modal-overlay"
          @click.self="handleClose"
      >
        <div
            :style="{ zIndex: modalZIndex }"
            class="modal-content"
        >
          <button
              v-if="!hideCloseButton"
              class="modal-close btn btn-transparent"
              @click="handleClose"
          >
            <i class="i-times" />
          </button>
          <slot></slot>
        </div>
      </div>
    </Teleport>
  </client-only>
</template>

<script lang="ts" setup>
import {computed} from 'vue'
import {useModalStore} from '~/store/modal'
import type {ModalIds} from "~/types/Modals";

const props = withDefaults(defineProps<{
  modalId: ModalIds
  closeOnOverlayClick?: boolean
  hideCloseButton?: boolean
}>(), {
  closeOnOverlayClick: true
})

const modalStore = useModalStore()

const isOpen = computed(() => modalStore.isModalOpen(props.modalId))
const modalZIndex = computed(() => modalStore.getModalZIndex(props.modalId))
const overlayZIndex = computed(() => modalStore.getOverlayZIndex(props.modalId))

const handleClose = () => {
  if (props.closeOnOverlayClick) {
    modalStore.closeModal(props.modalId)
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.modal-content {
  background: var(--surfaces-container);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  max-width: 80vw;
  max-height: 90vh;
  overflow-y: auto;
  margin: 0 auto;
  position: relative;
  @media screen and (max-width: 768px) {
    max-width: 90vw;
  }
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
  z-index: 1;
}
</style>
